import Api from "../../config/api";
import {
  CREATE_PAYMENT,
  SEARCH_PAYMENT,
  SEARCH_PAYMENT_BY_ID,
  UPDATE_PAYMENT,
} from "../../utils/constants";
import { showToast } from "../toast/ShowToast";

export const getPayment = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_PAYMENT, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getPaymentById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_PAYMENT_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createPayment = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_PAYMENT, body);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      let msg = error?.response?.data?.message.split(":");
      if (msg[2] === " number_1_company_1 dup key") {
        showToast(`Payment number already taken`, "error");
        hideLoader();
        return error;
      } else {
        showToast(`${error?.response?.data?.message}`, "error");
        hideLoader();
      }
    }
  }
};

export const updatePayment = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_PAYMENT}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
